import React from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { USERS } from "@/constants/testIds";
import { useUserDetail } from "@/hooks/useUserDetail";
import {
  SocialToggleCard, TemplateAssignSelect, UserContactCard, UserIdentityHeader,
} from "@/components/users/UserDetailParts";

export function UserDetailSheet({ user, templates, open, onClose, onUpdated }) {
  const detail = useUserDetail(user, onClose, onUpdated);

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="bg-white sm:max-w-md overflow-y-auto">
        <SheetHeader>
          <SheetTitle className="text-slate-900">Detalle de usuario</SheetTitle>
        </SheetHeader>
        {user && (
          <div className="mt-6 space-y-5">
            <UserIdentityHeader user={user} />
            <UserContactCard user={user} />
            <TemplateAssignSelect value={detail.selectedTemplate} onChange={detail.setSelectedTemplate}
              templates={templates} noneValue={detail.NO_TEMPLATE} />
            <SocialToggleCard checked={detail.showSocialMedia} onChange={detail.toggleSocial}
              disabled={detail.savingPrefs} />
            <div className="flex justify-end gap-2 pt-4 border-t border-slate-200">
              <Button variant="outline" onClick={onClose} className="border-slate-200">Cancelar</Button>
              <Button onClick={detail.saveAssign} className="bg-orange-600 hover:bg-orange-700 text-white"
                data-testid={USERS.saveAssignBtn}>
                Guardar
              </Button>
            </div>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
